import { dataM } from './create-api'
export function values () {
  return dataM().get('/api/values')
}
